export const ACTIVE_STATUS_KEY = 'A';
export const CANCELLED_STATUS_KEY = 'C';
export const COVERAGE_LEVEL_SINGLE_KEY = 'S';
export const COVERAGE_LEVEL_FAMILY_KEY = 'F';
export const COVERAGE_LEVEL_SINGLE_LABEL = 'Single';
export const COVERAGE_LEVEL_FAMILY_LABEL = 'Family';

export interface EnrollmentIdentifiersForm {
  tpa_partner: string;
  employer: string;
  employer_employee_id?: string;
  partner_employee_id?: string;
  ssn?: string;
  last_name: string;
}

export interface EnrollmentPlanForm {
  coverage_level?: string;
  coverage_level_effective_date?: string;

  plan: string;
  plan_year: string;
  plan_start_date: string;
  plan_end_date: string;
  enrollment_status: string;
  election_amount: string;
  enrollment_date: string;
  deductible_met?: string;
  per_pay_employee?: string;
  per_pay_employer?: string;
  limited_use?: LimitedUses;
}

export interface EnrollmentHealthPlanForm {
  health_plan: string;
  health_plan_year: string;
  health_plan_coverage: string;
  health_plan_enrollment_date: string;
  health_plan_start_date: string;
  health_plan_end_date: string;
}

export interface AddEnrollmentForm
  extends EnrollmentIdentifiersForm, EnrollmentHealthPlanForm, EnrollmentPlanForm {
  deductibleMetDate?: string;
  type: PlanTypes;
}

export enum LimitedUses {
  LIMITED_USE = 'Limited Use',
  GENERALE_PURPOSE = 'General Purpose',
  GENERALE_PURPOSE_DEDUCTIBLE_MET = 'General Purpose - Deductible Met',
}

export enum PlanTypes {
  SAVING = 'Saving plan',
  HEALTH = 'Health plan',
}

export const PlanTypesOptions = [
  {
    id: '1',
    label: PlanTypes.SAVING,
    value: PlanTypes.SAVING,
  },
  {
    id: '2',
    label: PlanTypes.HEALTH,
    value: PlanTypes.HEALTH,
  },
];
